import { useSelector } from 'react-redux'
import { RootState } from '../store'

/**
 * Whether this user is the one who talks to ARIAS about the contract.
 *
 * Entitlements are a commercial fact before they are a technical one: a
 * feature arrives with a contract on SaaS and with a licence on-premises, and
 * in both cases one person owns that conversation — the tenant admin, or a
 * platform admin. Telling every viewer and analyst to "contact sales" invites
 * four people to email about one upgrade, and tells the three who cannot act
 * on it to do something they are not able to do.
 *
 * Roles are viewer, analyst, manager and admin; `type` separates a platform
 * admin from a tenant user. Manager is deliberately excluded: it confers
 * operational scope, not commercial authority, which is why the cost page
 * uses its own admin-or-manager check for pricing and this is separate from
 * it.
 *
 * What this does *not* do is hide anything. The message stays visible to
 * everyone, because a feature that silently disappears reads as a product
 * that is broken; only the suggested action changes.
 */
export const useCanContactVendor = (): boolean => {
  const { user } = useSelector((state: RootState) => state.auth)
  return user?.type === 'admin' || user?.role === 'admin'
}

export default useCanContactVendor
